import React from 'react';
import { useAppSelector, useAppDispatch } from '../../hooks/useRedux';
import { useEstabelecimento } from '../../hooks/useEstabelecimento';
import { realizarLogout } from '../../armazenamento';
import { obterCustomizacaoValida } from '../../utilitarios/customizacao';
import SeletorEstabelecimento from './SeletorEstabelecimento';

/**
 * Cabeçalho da aplicação.
 * Requisitos: 6
 *
 * - Exibe logo e nome do estabelecimento atual (ConfiguracaoEstabelecimento)
 * - Exibe nome do usuário logado e botão de logout
 * - Aplica cores customizadas do estabelecimento
 */
const Cabecalho: React.FC = () => {
  const dispatch = useAppDispatch();
  const { lojista } = useAppSelector((estado) => estado.autenticacao);
  const { estabelecimentoAtual } = useEstabelecimento();

  const customizacao = obterCustomizacaoValida(estabelecimentoAtual?.customizacao);

  const aoClicarLogout = () => {
    dispatch(realizarLogout());
  };

  return (
    <header
      className="cabecalho"
      style={{
        backgroundColor: customizacao.corPrimaria,
        color: customizacao.corTexto,
      }}
    >
      <div className="cabecalho__esquerda">
        <img
          src={customizacao.urlLogo}
          alt={`Logo ${customizacao.nomeEstabelecimento}`}
          className="cabecalho__logo"
          onError={(e) => {
            const img = e.target as HTMLImageElement;
            // Evita loop infinito: só aplica fallback se ainda não tentou
            if (!img.dataset.fallback) {
              img.dataset.fallback = '1';
              img.src = '/logo-padrao.svg';
            }
          }}
        />
        <span className="cabecalho__nome-estabelecimento">
          {customizacao.nomeEstabelecimento}
        </span>
        <span className="cabecalho__versao">v{__APP_VERSION__}</span>
      </div>

      <div className="cabecalho__direita">
        <SeletorEstabelecimento />
        {lojista && (
          <span className="cabecalho__nome-usuario">
            {lojista.nome}
          </span>
        )}
        <button
          className="cabecalho__botao-logout"
          onClick={aoClicarLogout}
          title="Sair"
          style={{
            backgroundColor: customizacao.corDestaque,
            color: customizacao.corTexto,
          }}
        >
          Sair
        </button>
      </div>
    </header>
  );
};

export default Cabecalho;
